import { formatMoney, postRequest } from "../../../Utils/Functions";
import { useUser } from "../../User/User.hook";
import { useEffect, useState, useRef } from "react";
import { gql } from "@apollo/client/core";
import { useQuery } from "@apollo/client";

const MAPFRE_SERVICE = "https://prod.infocasas.com.uy/microservices/simulador/?/mapfre/simulation";
const QUERY_PRICE = gql`
	query property($id: ID) {
		property(id: $id) {
			price {
				currency {
				  name
				}
				amount
			}
		}
	}
`;

export const useMapfreFinancing = ({ property_id, source = 0 }) => {
	const { data: propertyData } = useQuery(QUERY_PRICE, { variables: { id: property_id } });
	const { user } = useUser();
	const [loading, setLoading] = useState(true);
	const [priceAmount, setPriceAmount] = useState(0);
	const [currency, setCurrency] = useState(null);
	const [minimumIncome, setMinimumIncome] = useState(0);
	const [annualFees, setAnnualFees] = useState(0);
	const [cash, setCash] = useState(0);
	const [extraData, setExtraData] = useState(null);
	const timerRef = useRef(null);

	useEffect(() => {
		if (priceAmount > 0 && currency) {
			const callMapfreService = async () => {
			await mapfreService(true, priceAmount);
			};
		
			callMapfreService();
		}
	}, [priceAmount, currency]);

	useEffect(() => {
		if (propertyData && propertyData.property) {
			setPriceAmount(propertyData?.property?.price?.amount)
			setCurrency(propertyData?.property?.price?.currency?.name)
		}
	}, [propertyData])

	const mapfreService = async (dontStore: boolean, value) => {
		setLoading(true);
		const userId =
			user && user.data && user.data.me && user.data.me.id ? user.data.me.id : "";

		let data = await postRequest(MAPFRE_SERVICE + (dontStore ? `/${dontStore}` : ""), {
			monto: value,
			IDpropiedad: property_id,
			IDusuario: userId,
			source: source,
		});

		if (data) {
			setPriceAmount(value);
			setMinimumIncome(data.ingresos_necesarios);
			setAnnualFees(data.costo_12_cuotas);
			setCash(data.costo_contado);
			setExtraData({
				importe_alquiler: formatMoney(priceAmount),
				ingresos_necesarios: `${currency} ${formatMoney(data.ingresos_necesarios)}`,
				costo_contado: `${currency} ${formatMoney(data.costo_contado)}`,
				costo_3_cuotas: `${currency} ${formatMoney(data.costo_3_cuotas)}`,
				costo_12_cuotas: `${currency} ${formatMoney(data.costo_12_cuotas)}`,
			});
			setLoading(false);
		}
	};

	const changePriceAmount = (value) => {
		if (timerRef.current) {
		  clearTimeout(timerRef.current);
		}
		timerRef.current = setTimeout(() => {
		  if (value > 0) {
			mapfreService(false, value);
		  }
		}, 1200);
	  };
	
	  useEffect(() => {
		return () => {
		  if (timerRef.current) {
			clearTimeout(timerRef.current);
		  }
		};
	  }, []);

	return {
		loading,
		currency,
		priceAmount: {
			value: priceAmount,
			change: changePriceAmount,
		},
		minimumIncome,
		annualFees,
		cash,
		extraData,
	};
};